import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-two-oracle-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "338px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.32075471698113%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/7cabbf6bc5aae43b7222f24bf5daa376/dda86/7_Logo_ORACLE.webp 265w", "/document-services/static/7cabbf6bc5aae43b7222f24bf5daa376/5976e/7_Logo_ORACLE.webp 338w"],
            "sizes": "(max-width: 338px) 100vw, 338px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/7cabbf6bc5aae43b7222f24bf5daa376/28773/7_Logo_ORACLE.png 265w", "/document-services/static/7cabbf6bc5aae43b7222f24bf5daa376/74935/7_Logo_ORACLE.png 338w"],
            "sizes": "(max-width: 338px) 100vw, 338px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/7cabbf6bc5aae43b7222f24bf5daa376/74935/7_Logo_ORACLE.png",
            "alt": "ORACLE logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-two-oracle-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "205px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "45.853658536585364%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5d143feb161f1f81a4bce3e31baa92db/70b12/7_Logo_ADP.webp 205w"],
            "sizes": "(max-width: 205px) 100vw, 205px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/5d143feb161f1f81a4bce3e31baa92db/182e3/7_Logo_ADP.png 205w"],
            "sizes": "(max-width: 205px) 100vw, 205px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/5d143feb161f1f81a4bce3e31baa92db/182e3/7_Logo_ADP.png",
            "alt": "ADP logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-two-oracle-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "291px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "32.45283018867924%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/854a5b63848e8b9dd2f34e3005efd80c/dda86/7_Logo_Vrbo.webp 265w", "/document-services/static/854a5b63848e8b9dd2f34e3005efd80c/dca18/7_Logo_Vrbo.webp 291w"],
            "sizes": "(max-width: 291px) 100vw, 291px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/854a5b63848e8b9dd2f34e3005efd80c/28773/7_Logo_Vrbo.png 265w", "/document-services/static/854a5b63848e8b9dd2f34e3005efd80c/b3b34/7_Logo_Vrbo.png 291w"],
            "sizes": "(max-width: 291px) 100vw, 291px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/854a5b63848e8b9dd2f34e3005efd80c/b3b34/7_Logo_Vrbo.png",
            "alt": "Vrbo logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-two-oracle-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "389px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "24.150943396226417%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/eef82b75f534910f43976ff5e993822a/dda86/7_Logo_AVIONTE.webp 265w", "/document-services/static/eef82b75f534910f43976ff5e993822a/d9794/7_Logo_AVIONTE.webp 389w"],
            "sizes": "(max-width: 389px) 100vw, 389px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/eef82b75f534910f43976ff5e993822a/28773/7_Logo_AVIONTE.png 265w", "/document-services/static/eef82b75f534910f43976ff5e993822a/df799/7_Logo_AVIONTE.png 389w"],
            "sizes": "(max-width: 389px) 100vw, 389px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/eef82b75f534910f43976ff5e993822a/df799/7_Logo_AVIONTE.png",
            "alt": "AVIONTE logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" theme="lightest" width="20%" imageOnly className="sign-two-oracle-logo padding_top_align margin-top-zero imageHightAuto" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "342px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "30.566037735849054%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/75599ae4e4021377c8842e61bce83007/dda86/7_Logo_IMMeSign.webp 265w", "/document-services/static/75599ae4e4021377c8842e61bce83007/04b88/7_Logo_IMMeSign.webp 342w"],
            "sizes": "(max-width: 342px) 100vw, 342px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/75599ae4e4021377c8842e61bce83007/28773/7_Logo_IMMeSign.png 265w", "/document-services/static/75599ae4e4021377c8842e61bce83007/28260/7_Logo_IMMeSign.png 342w"],
            "sizes": "(max-width: 342px) 100vw, 342px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/75599ae4e4021377c8842e61bce83007/28260/7_Logo_IMMeSign.png",
            "alt": "IMMeSign logo",
            "title": "EMPTY_TITLE",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      